export var dataPrimes = [
    {
        id: "8b2141ee-8fb4-479f-be8f-0ef62878571a",
        name: "Plan A",
        scenaries: [
            {
                id: "f7507ebc-3b55-4d02-9de3-1feee9ba5a9f",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "98.00",
            },
            {
                id: "21b30602-ec20-4e34-9eed-bb5dba92e1ed",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "443.00",
            },
            {
                id: "fecb1add-1de7-4451-b608-c135f0b75821",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "886.00",
            },
            {
                id: "acf31120-77fc-4489-9f28-bd9a9b79a706",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "1,771.00",
            },
            {
                id: "b5238d8c-c5d4-470e-bd59-99196879eee4",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "173.00",
            },
            {
                id: "3e3760c7-5643-44e7-8744-aef81bd48c91",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "518.00",
            },
            {
                id: "ac07a2a8-6d4f-4f64-a2ae-c571f525cdae",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "1,037.00",
            },
            {
                id: "b286e27b-f637-42b4-ab39-17c709d394de",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "2,074.00",
            },
            {
                id: "2517c707-c88e-47a7-bc5a-d3f09ea518b4",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "379.00",
            },
            {
                id: "80883459-9c48-4961-adb9-040d1189d6d3",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "1,138.00",
            },
            {
                id: "ecc35ca9-fa98-4eb4-962c-d2a629aae533",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "2,275.00",
            },
            {
                id: "daa8cc13-cd80-42d2-815c-a7c9e8dcad58",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "4,550.00",
            },
            {
                id: "c8175ab8-7c15-4f4d-9b92-832dc3b57dc0",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "929.00",
            },
            {
                id: "9db43991-fd20-45ed-aeee-20be7ab3db35",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "2,786.00",
            },
            {
                id: "e72e7ae6-3f27-4413-b203-26e2a1567b06",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "5,573.00",
            },
            {
                id: "4a4f5275-1c10-49e8-ad22-895d7226a46b",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "11,146.00",
            },
            {
                id: "a533f1fa-e245-4005-9464-d6e223af039e",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "1,733.00",
            },
            {
                id: "f92fd3ea-e202-4f7f-a4fb-9401e3f212be",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "5,198.00",
            },
            {
                id: "9c1e32ef-8695-45c6-9637-ba700c60a982",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "10,397.00",
            },
            {
                id: "436a1bfa-a304-40e5-845c-e991f69f03f0",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "20,794.00",
            },
        ],
    },
    {
        id: "f04371a9-1e51-4da7-b53b-cb7b44ef74be",
        name: "Plan B",
        scenaries: [
            {
                id: "217c775a-3a66-4a94-9449-cbfa5a43a2bc",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "148.00",
            },
            {
                id: "2186c676-5a4a-4e7d-89f3-b3012a624021",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "443.00",
            },
            {
                id: "aa3e6bbc-1dcf-4b92-8075-811645681ef6",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "886.00",
            },
            {
                id: "f03bb68d-03fd-4349-a958-add9f0275653",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "1,771.00",
            },
            {
                id: "c352f3e6-8458-4ca6-aa9e-f9c388874fb9",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "259.00",
            },
            {
                id: "1bd2fe83-492e-4e58-9b11-41b303502a00",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "778.00",
            },
            {
                id: "6df5cc74-35dd-459e-861b-3acdb96715e2",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "1,555.00",
            },
            {
                id: "31ddb3a6-0089-4841-be65-5f49bce0eb21",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "3,110.00",
            },
            {
                id: "546a8eb2-df2e-4198-908f-cc58e292edb4",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "569.00",
            },
            {
                id: "f73d303c-fbf4-4db9-81e1-78d6eeb6b2fc",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "1,706.00",
            },
            {
                id: "b6bb49f5-742e-4793-8c25-142ddbd5f5f2",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "3,413.00",
            },
            {
                id: "71a51113-639d-4076-844c-aabcad71862b",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "6,826.00",
            },
            {
                id: "07aae160-e604-4364-b39d-73b59f103a8d",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "1,393.00",
            },
            {
                id: "773ef240-aa66-4b5c-8fa5-10fa985a2fc5",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "4,180.00",
            },
            {
                id: "50d777d6-8e7d-48a0-9238-0b133af54b50",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "8,359.00",
            },
            {
                id: "3ec60ca4-059e-4dfe-9ff2-9805be1eb212",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "16,718.00",
            },
            {
                id: "49019cdb-b7d1-450e-80b8-8241fd24994f",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "2,599.00",
            },
            {
                id: "2ad12a75-d941-4af8-a91f-5cbfdcef1325",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "7,798.00",
            },
            {
                id: "b5fb8da1-56ac-4c11-8d42-1752cb6419b7",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "15,595.00",
            },
            {
                id: "5564f10b-ca1e-44f6-bcb9-73a1b1193af3",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "31,190.00",
            },
        ],
    },
    {
        id: "e0dfea78-77ef-4f43-828f-8337ec22cb7a",
        name: "Plan C",
        scenaries: [
            {
                id: "943387c2-9024-43d9-b43f-05d06139aea3",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "246.00",
            },
            {
                id: "31eedb8a-5764-4b41-8d18-ca655e088be0",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "738.00",
            },
            {
                id: "ec432ed7-ae67-4876-94a9-6b45758216db",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "1,476.00",
            },
            {
                id: "8d50549f-e168-445d-9d4d-4512a63aa378",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "2,952.00",
            },
            {
                id: "e6101739-98db-4545-a1d6-c0e9ed8c230b",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "431.00",
            },
            {
                id: "a3f95fdc-81e3-43bb-829a-cb66eb535ce3",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "1,292.00",
            },
            {
                id: "d616c242-3d73-4656-84a3-534dea422a1b",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "2,585.00",
            },
            {
                id: "6cbcfd42-7354-46da-a8bd-afd7cd7a3f8a",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "5,170.00",
            },
            {
                id: "c0dae8b9-e56a-4651-91cc-dd8d1fb6a9c0",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "948.00",
            },
            {
                id: "d6a03037-dd9b-41e5-9cf2-2658afe556e5",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "2,844.00",
            },
            {
                id: "f312ac62-c46b-40e9-b675-281e3f76a6e5",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "5,688.00",
            },
            {
                id: "586a115d-e54b-49b0-979f-bfacb5aca91f",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "11,376.00",
            },
            {
                id: "65e52d69-a556-494b-b15c-7309b77c59d4",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "2,322.00",
            },
            {
                id: "275e94b7-4836-45d7-adfe-9a7cd1bb9d3c",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "6,966.00",
            },
            {
                id: "30819510-3fb9-4912-adef-2d0e3063d647",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "13,932.00",
            },
            {
                id: "a7193cf7-0ff6-4ec0-a427-9d7b4b5fce3b",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "27,864.00",
            },
            {
                id: "f8f07ee1-4647-4b11-9755-4039a911991c",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "4,332.00",
            },
            {
                id: "43804e47-eab9-4904-9be4-7fb5606e13d2",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "12,996.00",
            },
            {
                id: "7db9ad2b-5fb6-487e-8735-6faabe6a5f74",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "25,992.00",
            },
            {
                id: "a334d997-5ebe-46fd-af87-ba3dec6e51c8",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "51,984.00",
            },
        ],
    },
    {
        id: "94ca2a16-d94c-426f-9028-3f62639405de",
        name: "Plan D",
        scenaries: [
            {
                id: "e55321e6-aea3-4f30-81b4-4e6f6973d272",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "344.00",
            },
            {
                id: "5cdb88a2-03a3-4496-b240-df8d63f2640d",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "1,033.00",
            },
            {
                id: "24118e44-767f-41f4-b40f-b66f1f3c23c8",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "2,066.00",
            },
            {
                id: "383e9770-8bd6-4fe4-9cec-271d2d06b055",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "4,133.00",
            },
            {
                id: "1c433f59-9a6b-40c3-b5b3-5d60b0374926",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "602.00",
            },
            {
                id: "2cce9429-79c7-4a6f-9f90-c1683e692f11",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "1,807.00",
            },
            {
                id: "260aec8e-cdb0-4d1d-a11b-709fae405917",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "3,614.00",
            },
            {
                id: "d12b6375-1d80-4f1b-9553-448eadc6cc9b",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "7,229.00",
            },
            {
                id: "a772dbb1-e985-4ab5-867c-029cc148135a",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "1,327.00",
            },
            {
                id: "3ccc21e9-a2a8-4bf0-a053-692e1e7e05cf",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "3,982.00",
            },
            {
                id: "a377ad78-b3c2-49e2-99b2-56c705fcfe7d",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "7,963.00",
            },
            {
                id: "697623bb-3908-455a-92ef-fd1f15115052",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "15,926.00",
            },
            {
                id: "54fd9794-7df3-4145-843d-264487c6a242",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "3,251.00",
            },
            {
                id: "57ff7dda-a2ed-4406-88cd-44919bf24e9d",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "9,752.00",
            },
            {
                id: "f22949f9-777c-46c3-a175-20dc6ede8507",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "19,505.00",
            },
            {
                id: "558a174b-83ca-4816-aa3e-d5eb15aaee88",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "39,010.00",
            },
            {
                id: "4c25454d-282a-4899-b0cb-7d9976590d71",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "6,065.00",
            },
            {
                id: "eaf369ef-1986-42a4-8f03-e7daf863d4a8",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "18,194.00",
            },
            {
                id: "1c1784f4-b5fc-4608-a26c-03baf06f94d4",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "36,389.00",
            },
            {
                id: "efc054a2-8a49-44c3-b3eb-eca0a046856f",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "72,778.00",
            },
        ],
    },
    {
        id: "0e3e4a00-33cc-402d-a9a1-c74d97da78a5",
        name: "Plan E",
        scenaries: [
            {
                id: "827fb8bd-5fb9-4dbc-bab1-e7f0944d8aa2",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "491.00",
            },
            {
                id: "2054d457-8338-4f32-89e6-53a24ae0d567",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "1,472.00",
            },
            {
                id: "5ee05bf4-77c7-4574-bf33-db2016fd8872",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "2,945.00",
            },
            {
                id: "82c58a11-1d38-4527-8529-2d3725945749",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "5,890.00",
            },
            {
                id: "0d5755d7-508b-4a04-8251-6d538b5dc9d7",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "860.00",
            },
            {
                id: "f5010599-f4a1-4363-b7e9-65ac86fad596",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "2,581.00",
            },
            {
                id: "68ec99bc-5862-40a4-a522-9cdcb461ac37",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "5,162.00",
            },
            {
                id: "3b6537d2-b378-4ab4-a2da-fc320220fc8b",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "10,325.00",
            },
            {
                id: "69e8ed3e-1157-4d7e-bc0e-8e0a2bf6df90",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "1,896.00",
            },
            {
                id: "1cbbbf63-d207-4bd1-951d-af4f1d503bf8",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "5,688.00",
            },
            {
                id: "a7456dae-b382-4feb-a6dc-dce27f0504c4",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "11,376.00",
            },
            {
                id: "921c7ccc-7c66-4ef0-91fa-8e0c7092f3a9",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "22,752.00",
            },
            {
                id: "6b6c5cfe-df84-48cb-aab8-6e4e01ec348b",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "4,644.00",
            },
            {
                id: "50268349-f113-40df-a079-9f6f31b60611",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "13,932.00",
            },
            {
                id: "46aebfc4-6b1e-4503-8e33-1edbf751d02b",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "27,864.00",
            },
            {
                id: "f807e783-f9b0-47b9-bc2e-cb2746a74f93",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "55,728.00",
            },
            {
                id: "30f6850d-d36d-44e1-98e6-cefd0ce1bb5e",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "8,664.00",
            },
            {
                id: "014d708a-3e9c-4e0e-860d-c7c5ec878034",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "25,992.00",
            },
            {
                id: "331b880a-5ab1-44b4-9662-e22702184800",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "51,984.00",
            },
            {
                id: "cf88209c-f1f6-4558-9067-d6efd49b2011",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "103,968.00",
            },
        ],
    },
    {
        id: "fe5bda68-ae19-4ffb-b891-7d30d5aa874d",
        name: "Plan F",
        scenaries: [
            {
                id: "3678c0c5-34da-42ab-9b33-cd5ab51dce7f",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "737.00",
            },
            {
                id: "b23c9ffd-08ca-4aea-a339-6d15b5540014",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "2,210.00",
            },
            {
                id: "a02ff336-2a1e-44b4-b0b0-92ef6c0a1470",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "4,421.00",
            },
            {
                id: "af99115a-b5ae-493c-b199-ea2efec32360",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "8,842.00",
            },
            {
                id: "58d2916d-86a3-492f-9488-37bd83e3c75d",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "1,291.00",
            },
            {
                id: "39abbd8f-af6a-41cd-bdb3-28bbd622b547",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "3,874.00",
            },
            {
                id: "7137389a-27fb-427a-afe2-381bd108b27f",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "7,747.00",
            },
            {
                id: "a2c89527-a5e6-4f6b-b24a-e2490bbf2c57",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "15,494.00",
            },
            {
                id: "7bf72f8c-ce4c-4b9b-8b83-9c065fa5c91c",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "2,844.00",
            },
            {
                id: "88cc1406-c0ca-41b9-bf4d-955eca41b595",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "8,532.00",
            },
            {
                id: "f5800f66-5b31-4892-9041-c769bb544a93",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "17,064.00",
            },
            {
                id: "c41adfdc-fa60-4380-979a-2284e0e3cdae",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "34,128.00",
            },
            {
                id: "1034d22b-162e-43ed-9fc8-b12d3c9808af",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "6,966.00",
            },
            {
                id: "25466085-194f-41f5-b6df-72e14c8db444",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "20,898.00",
            },
            {
                id: "48ee4e0e-01f6-43ec-8482-64e3fe8c97e6",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "46,596.00",
            },
            {
                id: "37fc6fe7-3979-4e7e-a909-365d1ebe5513",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "83,592.00",
            },
            {
                id: "eaeee50d-b6b5-4040-bb0f-0a5f1355eab6",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "12,996.00",
            },
            {
                id: "24018b99-c7eb-4680-ad72-3f255c719bbc",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "38,988.00",
            },
            {
                id: "d1125049-aaae-44fe-b2ec-973a2f8402fd",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "77,976.00",
            },
            {
                id: "11e6fb8c-53d9-46ad-aa14-c3fa1daf2eb3",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "155,952.00",
            },
        ],
    },
    {
        id: "4567b196-356f-46bb-8c4a-dbe696792383",
        name: "Plan G",
        scenaries: [
            {
                id: "373f7c3e-6f58-473e-9fe8-a05961d96c55",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "982.00",
            },
            {
                id: "26210862-6aea-4e94-a64a-d2e0d17a97e5",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "2,945.00",
            },
            {
                id: "6af3c1e9-a00b-4095-8870-e2ec5feeb7e8",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "5,890.00",
            },
            {
                id: "d1b8fcda-2d07-41eb-9745-8bb79e33bd6e",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "11,779.00",
            },
            {
                id: "0ad06bf4-c877-4d04-ac84-c02397c4ab9f",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "1,721.00",
            },
            {
                id: "24323b00-b8e2-4823-9a5c-2983ff43ccd5",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "5,162.00",
            },
            {
                id: "5b24a6ce-ea2c-4f29-9512-812519a4cb89",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "10,325.00",
            },
            {
                id: "4d4976b7-1352-477e-bba8-4eb59b631e1e",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "20,650.00",
            },
            {
                id: "82228fcb-fa27-4e84-a9e2-510bb74e7760",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "3,792.00",
            },
            {
                id: "a5e1ebd4-5dde-4125-b121-f4bd97339cd6",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "11,376.00",
            },
            {
                id: "a60dca60-9fa6-4262-837c-1b098c233c16",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "22,752.00",
            },
            {
                id: "ef8287b7-e895-4e21-9c4f-95974551d92c",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "44,304.00",
            },
            {
                id: "e9f49ee5-dc37-4acf-8a53-956953667715",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "9,288.00",
            },
            {
                id: "8c1119d0-d78b-4c89-afb7-8e410ab94c08",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "27,864.00",
            },
            {
                id: "ee43f329-f857-4f23-a809-fac606fa1572",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "55,728.00",
            },
            {
                id: "8d7d1de8-16ee-4b5b-9d44-d85cc327dc0e",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "111,456.00",
            },
            {
                id: "1be1f60b-b2b6-4919-b94b-111f4c023bb5",
                paymentModeId: "4c7adc23-d622-40bd-a3bb-2e41ba3051cd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "17,328.00",
            },
            {
                id: "ce2c1013-c8ee-46b0-a63f-9b601e4e5731",
                paymentModeId: "f7771902-4ae8-41dc-91b8-906aabe13fdc",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "51,984.00",
            },
            {
                id: "8fa6258a-e877-48f2-bd83-ec202ae9f6b3",
                paymentModeId: "0dc22798-c6c4-4eef-a223-d73ef1b451ef",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "103,968.00",
            },
            {
                id: "0cadd1eb-b313-4d15-8624-d56bded68cc1",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "207,936.00",
            },
        ],
    },
    {
        id: "d6da6b85-5b9e-434a-820f-f420f7425cff",
        name: "PLan 1,000,000",
        scenaries: [
            {
                id: "0efcfcb7-22f4-49ae-861d-0d2dfa90b9fe",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "18 - 20",
                currencySymbol: "RD$",
                price: "70.00",
            },
            {
                id: "664e0ab7-1141-4534-9fb2-36358e31bab0",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "21 - 25",
                currencySymbol: "RD$",
                price: "83.00",
            },
            {
                id: "57f1ee06-4414-4e65-b64e-6e2156782155",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "26 - 30",
                currencySymbol: "RD$",
                price: "112.00",
            },
            {
                id: "e116424f-9187-4235-b372-b31e9ca498b8",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "31 - 35",
                currencySymbol: "RD$",
                price: "172.00",
            },
            {
                id: "f01ae25d-1737-4831-8e55-19f50ffe4b74",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "36 - 40",
                currencySymbol: "RD$",
                price: "290.00",
            },
            {
                id: "b6378eae-1969-45cf-8021-d0a6f70ac81e",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "41 - 45",
                currencySymbol: "RD$",
                price: "450.00",
            },
            {
                id: "0a5abc70-db45-4479-8b7a-24ccfee910af",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "46 - 50",
                currencySymbol: "RD$",
                price: "697.00",
            },
            {
                id: "aa60448a-f2c6-4c28-94d0-3efe565346bf",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "51 - 55",
                currencySymbol: "RD$",
                price: "1,075.00",
            },
            {
                id: "5352b899-662d-4df3-bc6b-af6c93ce9a36",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "56 - 60",
                currencySymbol: "RD$",
                price: "1,418.00",
            },
            {
                id: "b37c759b-9ca1-4b21-a7a7-49f3f125e659",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "61 - 65",
                currencySymbol: "RD$",
                price: "2,900.00",
            },
        ],
    },
    {
        id: "8a9d7600-9183-4772-a386-69ee012a1865",
        name: "Plan 1,500,000",
        scenaries: [
            {
                id: "82efe51f-4f46-44e4-ae68-59961463e2b1",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "18 - 20",
                currencySymbol: "RD$",
                price: "93.00",
            },
            {
                id: "7589481d-a035-4cb1-8ddb-64d848bd9ff1",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "21 - 25",
                currencySymbol: "RD$",
                price: "113.00",
            },
            {
                id: "f8a15a95-5d59-4d08-a2e6-ae11a883a99b",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "26 - 30",
                currencySymbol: "RD$",
                price: "156.00",
            },
            {
                id: "8fc9f7df-bc06-45a9-aef9-f0ef2cc5f465",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "31 - 35",
                currencySymbol: "RD$",
                price: "246.00",
            },
            {
                id: "04ca858a-9bf9-4884-8311-6bb07a864207",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "36 - 40",
                currencySymbol: "RD$",
                price: "423.00",
            },
            {
                id: "c04f1b56-9417-498a-9244-5b4586480da4",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "41 - 45",
                currencySymbol: "RD$",
                price: "663.00",
            },
            {
                id: "f202c124-fb68-40e8-8729-d659ed871ed2",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "46 - 50",
                currencySymbol: "RD$",
                price: "1,033.00",
            },
            {
                id: "6c08a78f-9856-44bf-9558-91db3ffacde8",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "51 - 55",
                currencySymbol: "RD$",
                price: "1,601.00",
            },
            {
                id: "51965009-db64-4eaa-ad54-0aca69539a46",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "56 - 60",
                currencySymbol: "RD$",
                price: "2,116.00",
            },
            {
                id: "4d2b39ea-a879-4422-809d-d24865ca5eeb",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "61 - 65",
                currencySymbol: "RD$",
                price: "4,338.00",
            },
        ],
    },
    {
        id: "2af3464b-545d-44ac-8af2-8ae6c3fcb7f1",
        name: "Plan 2,000,000",
        scenaries: [
            {
                id: "a68985aa-938e-4616-947a-e3962ad6c4c8",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "18 - 20",
                currencySymbol: "RD$",
                price: "117.00",
            },
            {
                id: "ceb7ae3f-b3f7-4f7f-95d2-8f0a2617db08",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "21 - 25",
                currencySymbol: "RD$",
                price: "143.00",
            },
            {
                id: "e0a2e947-6cbb-40ea-b611-1d03b0cfe2ed",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "26 - 30",
                currencySymbol: "RD$",
                price: "200.00",
            },
            {
                id: "ff1dd370-dc8e-467c-a496-657a383deb85",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "31 - 35",
                currencySymbol: "RD$",
                price: "320.00",
            },
            {
                id: "d8b8bdb8-6084-43db-a131-b3d7290cfe20",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "36 - 40",
                currencySymbol: "RD$",
                price: "557.00",
            },
            {
                id: "caa43b37-c15c-4697-be92-365ce65c1321",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "41 - 45",
                currencySymbol: "RD$",
                price: "877.00",
            },
            {
                id: "f380b0f2-b0b6-4eba-97a1-9465b31814de",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "46 - 50",
                currencySymbol: "RD$",
                price: "1,370.00",
            },
            {
                id: "574300eb-e414-4dd9-9851-0693a4e7810b",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "51 - 55",
                currencySymbol: "RD$",
                price: "2,127.00",
            },
            {
                id: "040a4f7d-7e51-498a-b9c4-9149b799a67d",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "56 - 60",
                currencySymbol: "RD$",
                price: "2,813.00",
            },
            {
                id: "cfca32e5-4605-46cc-959c-8cbfa4f35e07",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "61 - 65",
                currencySymbol: "RD$",
                price: "5,777.00",
            },
        ],
    },
    {
        id: "753f3f7f-0ae5-4c1d-9be9-435f8971ad42",
        name: "Plan 2,500,000",
        scenaries: [
            {
                id: "a7e069da-dcdd-4811-b948-b9bdecf97d73",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "18 - 20",
                currencySymbol: "RD$",
                price: "430.00",
            },
            {
                id: "b552034f-e013-481b-aee5-b4c01610084d",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "21 - 25",
                currencySymbol: "RD$",
                price: "463.00",
            },
            {
                id: "039e7e25-921f-437b-b258-485cac776770",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "26 - 30",
                currencySymbol: "RD$",
                price: "534.00",
            },
            {
                id: "1bb2640e-7f86-4c92-a1a1-5582fce63f77",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "31 - 35",
                currencySymbol: "RD$",
                price: "684.00",
            },
            {
                id: "57f31f82-77bf-4d6d-9ad3-a5ea4ad2e5ff",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "36 - 40",
                currencySymbol: "RD$",
                price: "980.00",
            },
            {
                id: "95d9be1f-7372-497c-ab52-e6c47b89b5cb",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "41 - 45",
                currencySymbol: "RD$",
                price: "1,380.00",
            },
            {
                id: "297a75c0-ae6e-421a-876c-3b7cba0c8c97",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "46 - 50",
                currencySymbol: "RD$",
                price: "1,996.00",
            },
            {
                id: "f563a1bb-72cb-4d9c-a70a-6c8f4d93d2c3",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "51 - 55",
                currencySymbol: "RD$",
                price: "2,942.00",
            },
            {
                id: "1a7d64f1-87a2-4378-a02a-74fe840add74",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "56 - 60",
                currencySymbol: "RD$",
                price: "3,800.00",
            },
            {
                id: "13bc956f-40e4-44fe-9b4f-c0a769ffa01a",
                paymentModeId: "dccf9e9d-ca5c-429a-8f1e-f2f8f006667a",
                ageRange: "61 - 65",
                currencySymbol: "RD$",
                price: "7,505.00",
            },
        ],
    },
    // Plan I - RD$ 300,000.00
    {
        id: "8d0d8cc9-1817-4f1f-96b2-5dd5682f0ac5",
        name: "Plan I - RD$ 300,000.00",
        scenaries: [
            {
                id: "95bf3c2f-0319-491b-bf53-570385e2c5f0",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "54.00",
            },
            {
                id: "ee9c6ffc-b8c2-4dbc-8fb4-a1f19db982e3",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "128.00",
            },
            {
                id: "3b7e558a-4dd5-4748-bb7b-44e0fc4fe428",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "193.00",
            },
            {
                id: "2c2b3be5-4bd6-4399-98ef-362534c6d921",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "293.00",
            },
            {
                id: "3cd814d5-308b-45dc-9330-d37a150eaa6d",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "447.00",
            },
            {
                id: "752d6677-5f92-4664-bef5-9898f12c1d18",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "686.00",
            },
            {
                id: "54a76656-c347-4248-834f-ae9a2f857198",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "1,666.00",
            },
            {
                id: "03dec020-7a95-49f0-9b37-ba430765381d",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "162.00",
            },
            {
                id: "cf091c35-4447-43c1-941f-ba04b100f280",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "384.00",
            },
            {
                id: "f2e82f70-3814-4b1b-8b6f-ad4cee378259",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "579.00",
            },
            {
                id: "9021704a-4127-4991-b94f-7347b6fd0544",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "879.00",
            },
            {
                id: "e4e71c81-a109-4f37-82f3-b4cf157a6247",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "1,341.00",
            },
            {
                id: "e9b4cee6-b90a-4f3a-a0ff-ae4e71f28387",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "2,058.00",
            },
            {
                id: "bb0d530c-8a69-45b7-b3e9-da3942d3f135",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "4,998.00",
            },
            {
                id: "9e05b5e9-8421-4104-9747-af9275b5000a",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "324.00",
            },
            {
                id: "8b227995-d7b9-421f-8769-7fe44a4f4199",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "768.00",
            },
            {
                id: "1913d11f-9298-4d81-824d-78870425ef75",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "1,158.00",
            },
            {
                id: "263ffd19-ecdf-4a30-894f-50c85e997380",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "1,758.00",
            },
            {
                id: "89fbb723-81a3-4fe1-926d-3a49bccfdbfc",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "2,682.00",
            },
            {
                id: "a517caaf-f284-4acc-8704-892b3c7938a2",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "4,116.00",
            },
            {
                id: "c6042a25-6221-4445-b3b8-3d5370fc11d3",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "9,996.00",
            },
            {
                id: "e3eeca34-c96e-477b-ac31-448dc77cb881",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "648.00",
            },
            {
                id: "66863067-e355-47a9-93c3-d4156fd4bc25",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "1,536.00",
            },
            {
                id: "4b4489b1-ef8f-413f-a68f-8a09e00b74bb",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "2,316.00",
            },
            {
                id: "b2c865a3-5468-435f-91c4-4a7737ebc6a1",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "3,516.00",
            },
            {
                id: "12c1d7b3-6d2b-4e97-a5e3-c44701e5a197",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "5,364.00",
            },
            {
                id: "9517fa24-df1c-42d2-b869-d9852de56b74",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "8,232.00",
            },
            {
                id: "9f0c312a-71b5-4999-9e05-e041a733e44b",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "19,992.00",
            },
        ],
    },
    // Plan II - RD$ 500,000.00
    {
        id: "5636dc43-c09e-4fdc-846a-28d82019e9ca",
        name: "Plan II - RD$ 500,000.00",
        scenaries: [
            {
                id: "72a0a6fb-81fc-4686-962f-24d009dbe664",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "90.00",
            },
            {
                id: "8139419c-4fa4-472a-95fe-2569ea724b2b",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "213.00",
            },
            {
                id: "7837ffe8-478f-4aee-ad23-3f743370ed8f",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "321.00",
            },
            {
                id: "31295ac8-4d09-4e0c-82e9-3791d928291d",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "489.00",
            },
            {
                id: "08fc6d6d-efe1-433a-94c6-69769ec1ad20",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "745.00",
            },
            {
                id: "3d89391f-f999-4d95-805e-1c9c1dcc1498",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "1,143.00",
            },
            {
                id: "63d51e4d-b843-4fee-89ca-3c2708b95660",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "1,943.00",
            },
            {
                id: "df5c0f30-0e69-4fb0-8da7-1f4c2187eb7a",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "270.00",
            },
            {
                id: "d27160ab-973d-4718-993e-336388137a6d",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "639.00",
            },
            {
                id: "ba18b9cf-5b67-46d5-be92-537bdd54c713",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "963.00",
            },
            {
                id: "98367913-de62-497c-95bf-eb2f2bd9809b",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "1,467.00",
            },
            {
                id: "4a1e513d-e7eb-4a8d-8b22-bfc06bb247d1",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "2,235.00",
            },
            {
                id: "7c5e15b7-7464-4b70-84f6-98f2f871f0f6",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "3,429.00",
            },
            {
                id: "9b0cd106-b3d9-479c-ad86-a000b00fab6c",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "5,829.00",
            },
            {
                id: "0ed1b2c1-5560-428c-a281-8927ee8b3e4a",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "540.00",
            },
            {
                id: "05ab3fcf-5633-4681-981e-7aa1416c0f1b",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "1,278.00",
            },
            {
                id: "e73baaf2-b5fa-4a2b-87ac-9374f4ea901b",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "1,926.00",
            },
            {
                id: "4b11f08d-878b-45e5-b1c5-124f92fe5f04",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "2,934.00",
            },
            {
                id: "f74e561b-21c2-42fc-83b8-485a4565f3e0",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "4,470.00",
            },
            {
                id: "8e605fec-4f20-4e61-905c-bda64e3c4af3",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "6,858.00",
            },
            {
                id: "8d5d507f-2947-4ec9-8590-9b042c050125",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "11,658.00",
            },
            {
                id: "3440e1ba-0e8e-497a-ba10-77478fa026b1",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "1,080.00",
            },
            {
                id: "975dcb95-049e-484c-8c66-197dd67c2319",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "2,556.00",
            },
            {
                id: "51109fdb-0fdd-4dad-9743-9fb20fbc9444",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "3,852.00",
            },
            {
                id: "06d4e73d-0e11-40a0-8ec1-b119f08a2085",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "5,868.00",
            },
            {
                id: "c6e81333-3b90-4005-81be-e472df212451",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "8,940.00",
            },
            {
                id: "24f60ca1-f328-4704-9839-f064b323ae68",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "13,716.00",
            },
            {
                id: "5f79c8b4-c826-43a4-b658-da460c9d6b69",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "23,316.00",
            },
        ],
    },
    // Plan III - RD$ 1,000,000.00
    {
        id: "a35a7519-e929-468b-92f1-c8e524f769e4",
        name: "Plan III - RD$ 1,000,000.00",
        scenaries: [
            {
                id: "b2b28e93-b504-44c6-b627-ac46ffac73f0",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "148.00",
            },
            {
                id: "c99640f2-14b3-4f1e-9b8a-7c24f8d16a17",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "394.00",
            },
            {
                id: "d230ddb2-4edd-4a50-a374-0d66ca66922b",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "611.00",
            },
            {
                id: "d59b06b0-ee01-43b4-a0d5-ba3b0000ef4c",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "945.00",
            },
            {
                id: "2c43c16b-9764-402b-a10a-5ff894604311",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "1,459.00",
            },
            {
                id: "743c9ba0-8953-4517-87b8-022d0f0a247e",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "2,286.00",
            },
            {
                id: "07dd245a-be75-4ae3-b053-6b00e3b1dfad",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "3,886.00",
            },
            {
                id: "4f4ed329-7f21-4fb8-bda6-9b87b9661b9f",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "444.00",
            },
            {
                id: "4abe8ef3-0dd6-4aa2-922a-655960667127",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "1,182.00",
            },
            {
                id: "1645d165-2c0c-4f4b-a389-d4704b8b6c54",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "1,833.00",
            },
            {
                id: "4d8b732e-8cde-4ba9-b665-2f8d1ec70b3a",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "2,835.00",
            },
            {
                id: "bad69ba1-e4c8-4104-a65c-fb4f688c2523",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "4,377.00",
            },
            {
                id: "45d253e9-d854-4f51-a374-c14b09f51d7e",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "6,858.00",
            },
            {
                id: "e1fd55a3-2fc5-4b46-b532-3732c1464a69",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "11,658.00",
            },
            {
                id: "18d84ea5-f9b6-4549-a810-3e8bc9ee093e",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "888.00",
            },
            {
                id: "849f48eb-9f4b-4672-918b-0ecf6378580d",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "2,364.00",
            },
            {
                id: "3595b29a-3c21-482e-90e4-91c06ee1c1f4",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "3,666.00",
            },
            {
                id: "ce3ed9af-0222-4d34-926c-6ff7847dea0b",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "5,670.00",
            },
            {
                id: "e96d933a-3fc4-4e53-bc0a-976cb81c6c94",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "8,754.00",
            },
            {
                id: "86b99f21-4a86-4254-b238-9d3554c85e4d",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "13,716.00",
            },
            {
                id: "1d0deef9-65da-4d00-ab87-bb0c91365f14",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "23,316.00",
            },
            {
                id: "8ab26891-c7c9-4101-ac0a-8b7319914107",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "1,776.00",
            },
            {
                id: "2438aad0-894b-4c78-aaba-771d61e7e5b5",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "4,728.00",
            },
            {
                id: "cd68ccc6-45ce-4cb5-af22-4e6151687159",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "7,332.00",
            },
            {
                id: "5dd6440f-6713-4aa4-9d54-b6a8a8b641cf",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "11,340.00",
            },
            {
                id: "72f6898a-831b-4954-951c-27f488b7b8d1",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "17,508.00",
            },
            {
                id: "0aaf11bd-e540-46b3-828e-25b91e00a0d7",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "27,432.00",
            },
            {
                id: "6005730d-939a-422b-a787-c93f9a744e83",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "46,632.00",
            },
        ],
    },
    // Plan IV - RD$ 1,500,000.00
    {
        id: "a6bde215-ba7a-4a15-8867-d21aa66b4b4e",
        name: "Plan IV - RD$ 1,500,000.00",
        scenaries: [
            {
                id: "0f25331e-cf8f-41cf-abc4-3e4416338e1d",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "206.00",
            },
            {
                id: "80483cbb-56d1-4537-8aa8-532b75ba600a",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "575.00",
            },
            {
                id: "f9e06dfd-def5-449e-ba44-34e6d7b2fbb4",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "900.00",
            },
            {
                id: "7b54c7db-2453-4902-b9d6-eacc626285f0",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "1,402.00",
            },
            {
                id: "fe9c39f0-f502-4d19-adc1-f15feb66bfe3",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "2,173.00",
            },
            {
                id: "adbc3b14-388d-4404-9ffd-ed1e895a840a",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "3,529.00",
            },
            {
                id: "275bf2bf-482a-40be-b9c7-849bee2d8a75",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "5,929.00",
            },
            {
                id: "d0d7a46e-e9d9-4cb0-8bd3-9b8e62e213e8",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "618.00",
            },
            {
                id: "d815b087-8bbe-4ef3-87c6-af8668bde406",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "1,725.00",
            },
            {
                id: "b4591bc5-67a9-41ab-8d26-2d2d347ba636",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "2,700.00",
            },
            {
                id: "5203bb0f-39bc-469e-870a-a5f813a65dd8",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "4,206.00",
            },
            {
                id: "38749df9-7700-453e-8a83-8c4d8c886d66",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "6,519.00",
            },
            {
                id: "9714054f-dc16-4ded-b630-2b9ec1806414",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "10,587.00",
            },
            {
                id: "079466bf-ffd0-4959-ac3d-9c19a9481105",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "17,787.00",
            },
            {
                id: "0b6f5c82-84ed-4719-bffa-a82a15b598d4",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "1,236.00",
            },
            {
                id: "5f70bcd7-d2af-4d84-9f30-a14ea4e6d6a4",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "3,450.00",
            },
            {
                id: "1aaf80db-942c-4dff-8db3-8296c09b7351",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "5,400.00",
            },
            {
                id: "ffafb0af-ba7a-4da3-9bd8-b79943a0a4c1",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "8,412.00",
            },
            {
                id: "10f60b9d-fdfe-4d84-b2e4-2a850228869c",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "13,038.00",
            },
            {
                id: "116dec27-0885-4db0-9192-beec3e26aae8",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "21,174.00",
            },
            {
                id: "ba35ade9-65bc-40cd-a0fc-d3b85c317c11",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "35,574.00",
            },
            {
                id: "4442ab69-b8f1-4097-a65f-bbaff7028c0b",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "18 - 34",
                currencySymbol: "RD$",
                price: "2,472.00",
            },
            {
                id: "41e9a293-a820-42e3-b55f-46bbfac3c9b8",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "35 - 39",
                currencySymbol: "RD$",
                price: "6,900.00",
            },
            {
                id: "1237e69a-2558-43ff-9d8a-0a8cfc9c21bc",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "40 - 44",
                currencySymbol: "RD$",
                price: "10,800.00",
            },
            {
                id: "3f970fb2-0724-4a2d-82d3-9bf790de3349",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "45 - 49",
                currencySymbol: "RD$",
                price: "16,824.00",
            },
            {
                id: "2085ffce-085b-4456-9232-e56fe7a23d0d",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "50 - 54",
                currencySymbol: "RD$",
                price: "26,076.00",
            },
            {
                id: "102b8700-f26e-49d0-95ba-a3064a09c174",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "55 - 65",
                currencySymbol: "RD$",
                price: "42,348.00",
            },
            {
                id: "fed83f75-2dfb-46df-8284-3f7e991a0fe8",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "66 - 70",
                currencySymbol: "RD$",
                price: "71,148.00",
            },
        ],
    },
    // Plan desde CSV - Opción 1 (Grupo 1)
    {
        id: "c1bff5c9-300a-4d1f-9161-a463da048c4b",
        name: "Opción 1",
        scenaries: [
            // PaymentMode: baa9b47b-8956-4bdb-8466-31420d5155b1
            {
                id: "04ff3236-910f-455a-8a4c-f13db545943a",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "56.00",
            },
            {
                id: "b11905ad-b524-48ce-a09b-3589aa03798d",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "80.00",
            },
            {
                id: "fd11c1d7-d2f0-4f0a-9cd5-01425f0e16f1",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "222.00",
            },
            {
                id: "61b190b4-f7af-4cc4-9c53-b1facecfc14d",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "467.00",
            },
            {
                id: "0b053d66-0fa0-4079-adb3-d96455178b61",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "931.00",
            },
            // PaymentMode: 08581cd1-5488-4744-ba2c-411af74c5e21
            {
                id: "07a9b0ec-2b25-4558-b9e1-10e023d5ab94",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "168.00",
            },
            {
                id: "4beafe38-da72-4be5-a51f-81daf95076da",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "240.00",
            },
            {
                id: "607088c2-cf72-4002-b36a-3b874c136d33",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "666.00",
            },
            {
                id: "39507a32-4523-47b8-814a-8a137e318c09",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "1,401.00",
            },
            {
                id: "e53846a5-195b-4e6e-8f45-799f9cc9af1b",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "2,793.00",
            },
            // PaymentMode: 6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd
            {
                id: "bb6ab9a2-49fe-434a-a3e5-d1fcc4989b3d",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "336.00",
            },
            {
                id: "60e21cf6-9146-4023-beae-ea5dd220d4a6",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "480.00",
            },
            {
                id: "833f4e0c-0add-4624-ab0b-26258b5e0723",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "1,332.00",
            },
            {
                id: "9cccdce7-0629-4059-b822-226ae393e075",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "2,802.00",
            },
            {
                id: "554cf0f1-c3e9-4630-9348-595c3f99692e",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "5,586.00",
            },
            // PaymentMode: 40095366-5cda-49d7-a817-c7b8a65dbb09
            {
                id: "f40e7eaa-d57f-4888-b3e4-eaeb35d3d2da",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "672.00",
            },
            {
                id: "c81d37be-66f5-4896-adaf-37ce54e0c9a8",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "960.00",
            },
            {
                id: "def9f45a-0781-41b0-93d4-19dcabd4fe81",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "2,664.00",
            },
            {
                id: "c44587dc-5c73-4a02-aa77-c2f0be499155",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "5,604.00",
            },
            {
                id: "f750c6f2-4391-43d5-9f8a-068a927d3d4f",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "11,172.00",
            },
        ],
    },
    // Plan desde CSV - Opción 2
    {
        id: "2a198945-2215-482c-8dd9-23d07ee2f061",
        name: "Opción 2",
        scenaries: [
            // PaymentMode: baa9b47b-8956-4bdb-8466-31420d5155b1
            {
                id: "a845f800-fb4f-4b17-bf0f-2dd1bfedb3f3",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "169.00",
            },
            {
                id: "59676288-3451-4eb6-aaad-83bb4847917d",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "239.00",
            },
            {
                id: "96b18439-2273-4234-84e3-36c8560995cb",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "666.00",
            },
            {
                id: "399691fa-52ae-4a61-9238-72773906d20e",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "1,402.00",
            },
            {
                id: "2bd3c9fa-9f16-4e8d-b9b7-bc312c6ef233",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "2,794.00",
            },
            // PaymentMode: 08581cd1-5488-4744-ba2c-411af74c5e21
            {
                id: "6d07fb28-0f30-4e6d-9227-7fff4f62087d",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "507.00",
            },
            {
                id: "868d8818-09ef-4f50-b1e2-e5d8217ebd8c",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "717.00",
            },
            {
                id: "2740fbf5-0a9f-431f-b960-1ecf8b3af1ad",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "1,998.00",
            },
            {
                id: "fd9b9e15-7dae-4af9-9169-7255e967bec1",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "4,206.00",
            },
            {
                id: "c3c852e7-c875-4bad-a376-8f09b38f19ea",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "8,382.00",
            },
            // PaymentMode: 6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd
            {
                id: "d55a26a6-516b-4da2-abb5-c0ee6b0dcc62",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "1,014.00",
            },
            {
                id: "f085196d-7faa-468c-889d-a2d40197f2b3",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "1,434.00",
            },
            {
                id: "aca846da-dd1e-4fde-96d2-a620d8ebb5d2",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "3,996.00",
            },
            {
                id: "fa199122-ec63-4652-8906-3a97ed639908",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "8,412.00",
            },
            {
                id: "cad43a0d-4ca4-4117-85a6-cc454e6b3c55",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "65 - 79",
                currencySymbol: "RD$",
                price: "16,764.00",
            },
            // PaymentMode: 40095366-5cda-49d7-a817-c7b8a65dbb09
            {
                id: "92b0ef4e-fb76-4adc-b736-fb2f40d5405e",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "18 - 30",
                currencySymbol: "RD$",
                price: "2,028.00",
            },
            {
                id: "0cafa69a-3ba0-417d-945b-2c0e49c7f56d",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "2,868.00",
            },
            {
                id: "26f86bdf-e159-486e-903c-2b022add7c8f",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "7,992.00",
            },
            {
                id: "c08f12e2-0060-46ff-a509-6388f6dde202",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "16,824.00",
            },
            {
                id: "ff0f68d4-c4a4-4d44-9c3b-261761e8abe8",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "33,528.00",
            },
        ],
    },
    // Plan desde CSV - Opción 3
    {
        id: "af113a44-174f-47c0-8914-841b86c45a43",
        name: "Opción 3",
        scenaries: [
            // PaymentMode: baa9b47b-8956-4bdb-8466-31420d5155b1
            {
                id: "3f217a15-0da7-43e1-911a-9bbb85929f95",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "282.00",
            },
            {
                id: "2b7cf585-8ab5-4242-bdbb-2c0660e490ce",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "398.00",
            },
            {
                id: "094eb4aa-8369-4c0a-ab26-318d862edd50",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "1,110.00",
            },
            {
                id: "a2624f0f-ba13-4b6e-8891-d3f3bf546964",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "2,337.00",
            },
            {
                id: "df39a8a0-4399-4153-9c30-5b6920d2fbdc",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "4,657.00",
            },
            // PaymentMode: 08581cd1-5488-4744-ba2c-411af74c5e21
            {
                id: "341a42aa-b80a-47f4-a45f-ce2802585beb",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "846.00",
            },
            {
                id: "e1e95ed5-d172-4f78-8bcb-661e68fcb17d",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "1,194.00",
            },
            {
                id: "dc485cf8-705a-433e-a6cf-922f698d7b65",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "3,330.00",
            },
            {
                id: "8447de88-a96a-4fec-9cf1-439c9a4c76b9",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "7,011.00",
            },
            {
                id: "aecdbf3d-a13c-4842-b66c-0511ed50bf3e",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "13,971.00",
            },
            // PaymentMode: 6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd
            {
                id: "e01b7a7b-6fc6-44da-895e-dda3ba08cb36",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "1,692.00",
            },
            {
                id: "f254d488-fb10-497f-9048-e4402b29a8a0",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "2,388.00",
            },
            {
                id: "40c7a8bb-10ea-44a4-bcea-87324f1a4446",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "6,660.00",
            },
            {
                id: "f8f9ca45-d78a-461f-b622-c5e9abafeab9",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "14,022.00",
            },
            {
                id: "b6ae97bb-d89e-432e-b8bc-41e80fe52b81",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "27,942.00",
            },
            // PaymentMode: 40095366-5cda-49d7-a817-c7b8a65dbb09
            {
                id: "d42bf4dd-b4e1-4896-8f6d-22b12e7cd476",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "3,384.00",
            },
            {
                id: "c3f184c5-928c-414f-9017-e4aa2224d010",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "4,776.00",
            },
            {
                id: "7c639411-b406-4b35-a8e6-adff4d2e7e07",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "13,320.00",
            },
            {
                id: "dc310b6b-1cf0-407b-82e8-3dfcf98e4f76",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "28,044.00",
            },
            {
                id: "2fd52e3f-13de-49e2-a432-11104934365b",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "55,884.00",
            },
        ],
    },
    // Plan desde CSV - Opción 4
    {
        id: "067bfe33-2de2-4ccd-b964-c553cd4b6c4e",
        name: "Opción 4",
        scenaries: [
            // PaymentMode: baa9b47b-8956-4bdb-8466-31420d5155b1
            {
                id: "1fa50a08-d91d-48c1-b6cd-d47bddef476f",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "563.00",
            },
            {
                id: "965829fb-9c10-4c20-a231-802c212cccb1",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "795.00",
            },
            {
                id: "b6065c91-9eaa-4de9-ae23-757923f32dad",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "46 - 64",
                currencySymbol: "RD$",
                price: "2,221.00",
            },
            {
                id: "a2cac889-1867-4ddd-b5a9-9e9a903729b0",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "4,673.00",
            },
            {
                id: "0e73f457-05fe-484f-ba7a-9f549ca0c92e",
                paymentModeId: "baa9b47b-8956-4bdb-8466-31420d5155b1",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "9,313.00",
            },
            // PaymentMode: 08581cd1-5488-4744-ba2c-411af74c5e21
            {
                id: "ee84d644-8fee-412c-9967-2e78ba7a3319",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "1,689.00",
            },
            {
                id: "5d0ce941-f611-43c5-b365-ebe69641ff64",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "2,385.00",
            },
            {
                id: "ff6c57b9-e018-4a15-a780-030901a8ebf4",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "6,663.00",
            },
            {
                id: "21dc52d7-dfda-46ae-9dca-a6d6de9dc6b3",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "14,019.00",
            },
            {
                id: "96899faa-0b4d-4084-a107-3cad6df079fb",
                paymentModeId: "08581cd1-5488-4744-ba2c-411af74c5e21",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "27,939.00",
            },
            // PaymentMode: 6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd
            {
                id: "3c5ef44e-2911-4734-825a-2b59c41305af",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "3,378.00",
            },
            {
                id: "acc1135e-aa35-4cf7-97ec-d7433d40d013",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "4,770.00",
            },
            {
                id: "5fc7339a-3aac-437c-a359-f27f4d833021",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "13,326.00",
            },
            {
                id: "3634e990-6cff-4912-802a-d65e5d5faf0d",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "28,038.00",
            },
            {
                id: "5175a0ef-63eb-462e-af21-ecaf9a7d12a7",
                paymentModeId: "6d7eee83-10d8-4c5d-bbf7-e0c45ceb3dbd",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "55,878.00",
            },
            // PaymentMode: 40095366-5cda-49d7-a817-c7b8a65dbb09
            {
                id: "3c16aa0e-f658-4aab-87a8-f42eafeebeb1",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "18 - 29",
                currencySymbol: "RD$",
                price: "6,756.00",
            },
            {
                id: "caccb64a-9fc4-4106-b528-6f9bd01232ce",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "30 - 44",
                currencySymbol: "RD$",
                price: "9,540.00",
            },
            {
                id: "f607cc4a-dd4e-4751-8b0c-5af32e033395",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "45 - 54",
                currencySymbol: "RD$",
                price: "26,652.00",
            },
            {
                id: "50969a42-b80e-4c93-9e1a-4adf5a321d54",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "55 - 64",
                currencySymbol: "RD$",
                price: "56,076.00",
            },
            {
                id: "c4df4a9c-fa0d-4e66-bb46-b6b35417c16a",
                paymentModeId: "40095366-5cda-49d7-a817-c7b8a65dbb09",
                ageRange: "65 - 80",
                currencySymbol: "RD$",
                price: "111,756.00",
            },
        ],
    },
    //SIN
    {
        id: "b9d6ad5c-afcb-4927-ba98-de11e358bd8b",
        name: "Opción 3",
        scenaries: [
            {
                id: "8626197f-951a-4350-90ee-6953c5f897ef",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "8,350.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "95c0efe2-fda0-4988-800a-4d5005d95b8d",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "5,886.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "5660588e-dfcb-46c9-8d86-fb5ed8af6c1d",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "3,935.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "c90446d3-c32c-4df4-9ab3-490dca68d75b",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "3,229.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "8d85f48a-014a-4834-b067-e624cff487dd",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "2,512.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "45a19316-3461-49e2-b0cf-7b39b448bf98",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "1,931.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "c024cfe1-2800-4ebb-b4b5-1fa75a293ab2",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "1,548.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "75b6eddc-2b8e-4dbb-89bf-8de5212d2c09",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "1,379.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "ddd3305f-bd2c-4707-a0b3-954f96efe34a",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "1,179.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "d6629182-9e9e-48b5-8240-8285be212796",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "1,094.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "2e00af01-7e28-4d11-938b-dac3aebe7572",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,009.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "6b1d2363-4d94-44f1-bf5a-5cffac0cdd32",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "926.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "96ec5c40-7894-452e-91c1-294bf9d9855a",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "372.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "9f475850-60b0-446f-b5ad-a49383cefa4d",
        name: "Opción 3",
        scenaries: [
            {
                id: "2d6a4553-4cf8-423e-8335-553cd84770d5",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "372.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "f5138298-aa97-4876-ac4a-b3da24b4e1fc",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "926.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "3cb0c7b9-a711-4b6a-83cc-d024a9b27b6b",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,009.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "58b6e17f-01ba-4abf-bf18-01941214778c",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "1,094.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "6df4dce9-7469-496c-b564-a9c61aee48c7",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "1,179.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "c1fb5cc9-1312-4519-87f9-7eaab63694bb",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "1,379.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "352708a1-3d0e-44e4-998b-c7384170f570",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "1,548.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "34d6057c-3abe-4bc3-bdba-5f1ad4a41c8b",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "1,931.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "43fa2d39-90a7-4fc5-b734-c9e1d2d24494",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "2,512.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "dbca1ee8-5b0a-4477-8f21-72a842abf18b",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "3,229.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "b4bc543f-85ef-474b-9b8f-e5bbd6c4d5f7",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "3,935.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "3d526cf6-f844-4e28-aa15-2806a3a16f50",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "5,886.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "93e591dd-ac4f-4e2e-9b48-67ae5acfa474",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "8,350.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "6178afcf-18d9-4b7e-b717-c57ed9e02e00",
        name: "Opcion 2",
        scenaries: [
            {
                id: "cb39b525-689a-4f43-aad9-7555cdd19012",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "4,890.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "2e2a75b5-b2fb-49f9-b490-729b8e1bcd8e",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "7,316.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "b93841c5-56d8-4097-ab23-9e434c8d97ce",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "10,378.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "964990a4-4e9c-4645-ae53-15e6a56ee403",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "462.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "33d3a9f1-91f6-4973-987b-d56699ac7896",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "1,141.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "db795696-6fa5-4e26-a683-3d674daa45ce",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,252.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "ce7e5981-46a2-4937-b332-996704cf1635",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "1,352.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "cf76031d-9837-45e9-b9ac-a14896a5ac12",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "1,462.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "ed9c07d5-d203-47bd-8276-57e45080c791",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "1,702.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "7038b7b6-7fa7-4113-8fbb-d9b83b4f4129",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "1,925.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "9ceaf0bf-eb88-4eac-a443-fa05399d597c",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "2,394.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "e2465a76-e6c7-4f96-b4b5-b43f2fdff1cd",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "3,122.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "17a45f92-9c75-41c9-9670-3559911b9939",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "4,005.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "3d4beda9-7657-472f-a4d3-d4ff7af06983",
        name: "Opción 2",
        scenaries: [
            {
                id: "92d68f90-d9d1-48e0-b392-d3fdfc8c8053",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "10,378.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "dd28af5f-c887-4a11-bf87-1a81ab6eeae3",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "462.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "3d883f19-b256-4f53-8b4a-ae51b48d4151",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "1,141.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "5c31d4cc-f61e-4775-b1a4-73b24f41337c",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,252.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "e6a1b35f-a5f4-4e5a-8440-1290d3a75f4f",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "1,352.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "ea4d3877-67e5-4f8b-9e4d-598cd2fea3bd",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "1,462.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "3ba0870d-b83f-4db1-be9f-35bf61432d33",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "1,702.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "151ee207-abf9-4a80-8ded-59fcef45c42f",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "1,925.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "459cbcd8-b9f9-40b2-a588-3fa0b2a5ac8d",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "2,394.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "7fbb2e66-1ead-4b7d-bb98-f24bf5ba85c5",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "3,122.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "11c94386-a47e-4003-9712-d8c0df564e2b",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "4,005.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "06984500-f261-47f3-a66a-4dd9e6d31c4e",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "4,890.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "9f171eb3-c298-417f-8f88-586a8a496abd",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "7,316.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "89ef6e2c-1942-4ab5-af2c-d57b5257ab69",
        name: "Opción 1",
        scenaries: [
            {
                id: "e10db898-7570-41d5-84cd-fcf61a062794",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "576.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "a3a61f76-e86e-47b7-8065-99400bbfd626",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "2,984.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "dc75c55b-847f-44db-bef6-d70d4988e230",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "3,898.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "daf57162-9e32-4e6e-b9d5-4c856dea6f93",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "4,997.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "4abca0aa-3e39-4c76-9f10-f221104aba10",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "6,112.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "924ed3c9-d528-4c7c-a216-4ee61884afc8",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "9,145.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "612e97af-a257-4df0-bb55-db2e2c25a0ce",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "12,970.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "08c01d9a-83bb-476d-a53a-d0d6c0af02e0",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "2,406.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "da0ebbc2-9aaf-4c4c-820e-9c620f70a5a4",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "2,123.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "19fbdb4a-2eae-4998-9556-0d5e18ebc829",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "1,818.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "782fb719-b3e2-486a-b4aa-c0e7175e4013",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "1,685.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "b33a0706-c071-4cc9-ace4-ca380cc61569",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,563.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "3c3bfa6e-124b-4078-99f3-64cd1fa4dafe",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "1,420.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "e5586a12-83a2-43df-9019-14a07dcf8533",
        name: "Opción 1",
        scenaries: [
            {
                id: "e8b9d04e-043f-479b-b912-31507cb6d0e7",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "1,685.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "d8204d41-b56e-4931-8521-dd5d956d29bd",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "1,818.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "d599ac57-752f-436a-b620-00c3a271b852",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "576.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "e7ceabe5-dc88-4e59-9360-9bdf13cddcc7",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "2,123.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "3fdf20d4-4a8d-4d82-899e-d12fc43f81e9",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "2,406.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "8ae5095b-4abf-48df-80a9-ec69f3a50924",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "2,984.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "f26fcfc3-15b4-4d00-b570-971d24915406",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "6,112.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "23146953-91dc-44c8-ab3d-354add213b06",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "9,145.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "cfc54d7c-4f17-4eb7-a97d-d9a96251a141",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "12,970.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "ba70ddfc-1bab-4fff-9c64-037b5f688340",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "3,898.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "b5854675-7963-44ca-ae84-d67573631943",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "4,997.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "65b71931-e3b7-46f9-914c-9225cdccbcfe",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "1,420.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "26a14354-d5ff-41a8-95a2-2cfbfc410795",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,563.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "d1c0fc96-d45e-4e09-92d4-e16dfaf981b4",
        name: "Opción 2 - Premium",
        scenaries: [
            {
                id: "3be19e60-05cf-4af6-9893-d1ec203dc8c0",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "9,099.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "dfed8a13-9935-4c5e-99ab-6b91dae809ea",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "2,116.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "9e472447-672e-4117-a8e4-a2d5c4bca739",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "1,818.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "23aadce2-d56c-48db-9327-a5ee08798d82",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "1,681.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "26fcff7d-9614-4b42-809a-f38e70b9e56a",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "775.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "35fb5530-1844-4723-9649-4d02b3096474",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,557.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "6f726a0a-76d5-4c1d-b5ee-7a516d1c0365",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "1,543.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "2720e724-7a39-414d-b1a3-e6af0186867b",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "2,977.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "59800134-72b4-443b-b9fe-a29c2cd0170d",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "3,883.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "7540c2f3-34e3-4bec-ba35-78c6c105ea37",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "4,981.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "7cbc2d2f-4390-4eac-80fb-d978a2444bdf",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "6,081.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "efbf8b51-7495-4341-89d2-deb26e08cf53",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "2,394.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "4021db79-4dc2-4a33-a7fe-75d5fbb378bb",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "12,906.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "dcf3d676-3146-4f69-a373-85be3c73993a",
        name: "Opción 2 - Premium",
        scenaries: [
            {
                id: "bc871ad7-f8bf-4cb7-a893-3d673e46802b",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "775.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "a30375fb-73d9-476b-81dc-aaea63c2308d",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "6,081.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "ecf8ef0c-3a3f-4958-b1a8-f2020611d7e9",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "9,099.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "283ef2af-8735-4535-85a3-2310fbd08c8e",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "12,906.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "59d551c1-25c6-4b78-b9d7-7508178ea9ab",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "1,543.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "44c2ffb5-dccc-442f-a34d-fb9ae06fbd2c",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,557.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "093ee25e-ba44-4f62-9264-15b4478bffe5",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "1,681.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "e3353fdd-0332-4da3-b498-efeb13a54a94",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "1,818.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "063439f2-d6cc-4b58-a14a-47154f24532d",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "2,116.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "383cbbcf-ae20-4bb5-a558-5e0bb582eceb",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "2,394.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "8cfb92de-9728-4f90-b203-9740bc9aac9b",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "2,977.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "f7285693-2c61-4b68-842a-e65e91102267",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "3,883.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "36c623b4-c884-4f9c-8b8b-f0a8d2ece384",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "4,981.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "299162b7-d718-43b6-97e7-661aab82a8fb",
        name: "Opción 1-Premium",
        scenaries: [
            {
                id: "b19f38d7-f257-49d0-ab2b-c73151060fc3",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "4,805.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "e32b427e-45c3-45d1-baa3-7a51f9d8af07",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "15,988.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "d2af942b-3249-4ff9-bafd-2c98f1ff6925",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "11,273.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "523a104c-5b95-408c-a794-afe9f29ee829",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "7,534.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "2b183604-06bb-4df5-9eb6-ddc9a5985ad7",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "6,160.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "c43a23cc-e1bd-4edd-bd64-a2b9700bffaa",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "3,678.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "74d8b6c2-c4d7-43a8-91c7-0574f04f8695",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "2,966.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "93adac00-13bf-413f-ae57-f99d7d41188d",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "2,617.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "4c5f776d-d8e6-4a1e-bb8a-bbc715d277ec",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "2,241.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "2047120b-1c1a-4a13-b9ac-3caf01b09e53",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "2,078.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "96285238-eb4b-49b7-a3bc-bc81980dad97",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,927.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "1d574d84-1449-47ed-8582-b3f7808bb9b6",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "1,906.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "f2185ccb-f5df-444c-8000-b7a8478ebd73",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "962.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "2c4272cc-30db-4a38-be71-f5cab4ef7b18",
        name: "Opción 1-Premium",
        scenaries: [
            {
                id: "eb7fbb80-75cf-4181-bf9a-d77f3aa61b8c",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                price: "2,078.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "6b01dea1-6abb-4290-ab15-02f7e4941220",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                price: "15,988.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "cb486784-30a0-406f-ad62-12bf2094d9aa",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                price: "11,273.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "3a212f03-645d-4f11-b432-e9b84d1366ff",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                price: "7,534.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "0e35d112-1acd-40ee-834c-1702cad7a24a",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                price: "6,160.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "2af54a36-c57a-4a93-8b80-6d9ea3579860",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                price: "4,805.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "69727081-83ea-4e33-b8b7-ff3a9cc57ce2",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                price: "3,678.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "eb38c492-a8c5-42ed-a1ab-44a27b480155",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                price: "2,966.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "c4770db7-f2de-4453-a718-b2095e6b365c",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                price: "2,617.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "8593727b-b373-4129-8220-c19cd21c1495",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                price: "2,241.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "73959dfe-a76c-43e3-b82c-01f574977a5b",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                price: "1,927.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "69bd2dc8-6985-4bda-ac15-748290f23922",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                price: "1,906.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "2617f621-416b-420e-963d-7dae7fbc722e",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                price: "962.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
        ]
    },
    {
        id: "eb793565-6882-4d47-8b0a-cc339455cf54",
        name: "Opción 3 - Premium",
        scenaries: [
            {
                id: "b1542f14-f0d5-46e1-9481-8bc6ea17dae0",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "10,475.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "ffdaf13e-9909-45a0-b10b-e15b37f0897d",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "1,943.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "441416b7-3366-4e33-a658-601d49a3427e",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "2,423.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "2289b555-3989-4830-a792-d60da2393ced",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "3,151.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "766c6179-8648-4522-9a94-be7b7ac7a9e3",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "4,051.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "ce9068ff-0cc8-4caa-9b97-725235b3cfab",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "4,937.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "54068f94-8795-49f2-a373-6c92c3691d50",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "7,384.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "e14862f0-0d2d-4daa-8927-170b4f6fd6fe",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "629.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "663967cd-7124-4055-bb65-831f6b096556",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "1,263.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "e7871df2-9b30-4234-859e-25b95d135929",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "1,266.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "72d997bc-52bc-4122-bf64-becfb65adce1",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "1,373.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "0a8cc71d-0680-4457-8b16-6d7746952968",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "1,479.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "8e307a02-d753-4247-84fb-1a8e8a6c9c30",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                planId: "eb793565-6882-4d47-8b0a-cc339455cf54",
                price: "1,730.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    },
    {
        id: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
        name: "Opción 3 - Premium",
        scenaries: [
            {
                id: "4e39dfa6-ade1-4dc8-ae34-d535c6d16d5b",
                ageRange: "0 - 17",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "629.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "34342abf-e7b1-499c-a3b9-c1ede3a4c53d",
                ageRange: "18 - 24",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "1,263.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "fdc58874-6947-4c12-8613-733df625866c",
                ageRange: "25 - 29",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "1,266.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "39d1f173-3578-44fc-9b9e-1cc7cf147adc",
                ageRange: "30 - 34",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "1,373.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "95e747fc-b3f7-402a-b745-0eefea648ed2",
                ageRange: "35 - 39",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "1,479.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "37849bcf-6d00-497e-b57a-854e212603c9",
                ageRange: "40 - 44",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "1,730.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "2fa03e5a-2102-47a6-98db-521dcc37f7c7",
                ageRange: "45 - 49",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "1,943.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "1038b666-7e94-42b6-8020-79b3c7d76047",
                ageRange: "50 - 54",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "2,423.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "8daab36a-71fd-439e-95cd-37acafafef5a",
                ageRange: "55 - 59",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "3,151.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "56f0e5b8-8894-43ce-b0e1-1b487d7f3783",
                ageRange: "60 - 64",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "4,051.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "b08509c0-a7f5-43c7-a6e7-fae24b7e6fc6",
                ageRange: "65 - 69",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "4,937.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "450d4905-44fd-4586-bc40-cc85681d53c4",
                ageRange: "70 - 74",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "7,384.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            },
            {
                id: "12cdd45e-b226-455d-85e0-0638cfd82295",
                ageRange: "75 - 99",
                currencySymbol: "USD",
                planId: "a9484da9-dd7a-41af-a81a-a12c73e682d4",
                price: "10,475.00",
                paymentModeId: "aabedf92-8660-4012-924a-88b3760d47b8"
            }
        ]
    }
];
